<template>
    <div class="col-md-12">
        <div class="pt-3">
            <div class="row my-3">
                <div class="col-md-8">
                    <div class="h2">Receive goods</div>
                    <div class="flash-message">
                        <FlashMessage :position="'top'"></FlashMessage>
                    </div>
                </div>
                <div class="col-md-4">
                    <a :href="`/create-barcode/${warehouseId.id}`"
                       class="btn btn-success float-right d-flex align-items-center"
                       title="Create colli">
                        <span class="material-icons-outlined cursor-pointer mr-1">post_add</span>
                        <span>Create colli</span>
                    </a>
                </div>
            </div>
            <form @submit.prevent="receiveGoods">
                <div class="position-relative pagination-control">
                    <data-table
                        :url="tableReadyForLoading() ? url: null"
                        :filters="filters"
                        :columns="columns"
                        :per-page="perPage"
                        :translate="translate"
                        :classes="classes"
                        :order-by="orderBy"
                        :order-dir="orderDir"
                        :meta="columns.meta"
                        ref="table"
                        :debounce-delay=1000
                        @finished-loading="tableFinishLoading"
                    >
                        <div slot="filters" slot-scope="{ tableFilters, perPage, collis }">
                            <div class="row my-3 d-flex align-items-center">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="d-block mb-0 font-weight-bold">Select warehouse</label>
                                        <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                            <v-select
                                                class="booking-select"
                                                :options="warehouseList"
                                                v-model="warehouseId"
                                                @input="getDefaultLocation()"
                                                label="nickname"
                                            >
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="d-block mb-0 font-weight-bold">Select client</label>
                                        <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                            <v-select
                                                :options="clientList"
                                                v-model="filters.clientId"
                                                label="name"
                                                @input="getBookingList()"
                                            >
                                            </v-select>
                                        </div>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="colli.clientId==='' && isSubmit? 'border-danger':''">
                                        </div>
                                    </div>

                                    <div class="form-group" v-if="filters.clientId!==''">
                                        <label class="d-block mb-0 font-weight-bold">Select booking</label>
                                        <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                            <v-select
                                                :multiple="true"
                                                class="booking-select"
                                                :clearable="false"
                                                :clearSearchOnSelect="false"
                                                :options="bookingList"
                                                v-model="filters.bookingId"
                                                @input="onChangeBooking($event)"
                                                label="value"
                                                inputId="booking-select"
                                            >
                                            </v-select>
                                        </div>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="colli.clientId==='' && isSubmit? 'border-danger':''">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <thead v-if="filters.bookingId!==''" class="clickable-header" slot="header"
                               slot-scope="{ tableFilter }">
                        <tr v-if="filters.bookingId!==''">
                            <th v-if="column.visible===true"
                                v-for="column in columns">
                                <div class="d-flex align-items-center">
                                    <div v-if="column.label === 'Receive'" class="mr-2">
                                        <input type="checkbox"
                                               v-model="receiveAll"
                                               @change="onReceiveAll"
                                        >
                                    </div>
                                    <span> {{ column.label }} </span>
                                </div>
                            </th>
                        </tr>
                        </thead>
                        <tbody v-if="filters.bookingId!==''" ref="collisTable" slot="body" slot-scope="{ data }">
                        <tr
                            :key="colli.id"
                            :class="(key > 0 && data[key].booking && data[key].booking.id !== data[key - 1].booking.id) ? 'bold-border-top' : ''"
                            v-for="(colli,key) in data">
                            <td
                                :key="column.name"
                                v-for="column in columns"
                                v-if="column.visible!==false"
                            >
                                <data-table-cell
                                    :value="colli"
                                    :name="column.name"
                                    :meta="column.meta"
                                    :comp="column.component"
                                    :classes="column.classes">
                                </data-table-cell>

                                <slot v-if="column.label === 'Receive'">
                                    <div v-if="colli.received === null">
                                        <input type="checkbox"
                                               :checked="colli.received !== null"
                                               v-model="collis[colli.id]"
                                        >
                                    </div>
                                    <div v-if="colli.received !== null">
                                        <input type="checkbox"
                                               :checked="colli.received !== null"
                                               v-model="collis[colli.id]"
                                        >
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Booking'">
                                 <span v-if="colli.booking"> #B-{{colli.booking.id}} </span>
                                </slot>

                                <slot v-if="column.label === 'Reference'">
                                    <div v-if="editableRow==colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus
                                            border-2">
                                        <input type="text"
                                               required
                                               autocomplete="off"
                                               class="form-control text-left border-0 py-0 shadow-none form-input"
                                               v-model="colli.reference"
                                               v-on:input="updateColli($event,'colli_reference')"
                                        >
                                    </div>
                                    <div v-else>
                                        {{ colli.reference }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Name'">
                                    <div v-if="editableRow==colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus
                                            border-2">
                                        <input type="text"
                                               autocomplete="off"
                                               class="form-control text-left border-0 py-0 shadow-none form-input"
                                               v-model="colli.name"
                                               v-on:input="updateColli($event,'name')"
                                        >
                                    </div>
                                    <div v-else>
                                        {{ colli.name }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Volume'">
                                    <div v-if="editableRow==colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus
                                            border-2">
                                        <input type="text"
                                               required
                                               autocomplete="off"
                                               class="form-control text-left border-0 py-0 shadow-none form-input"
                                               v-model="colli.totalVolume"
                                               v-on:input="updateColli($event,'volume')"
                                        >
                                    </div>
                                    <div v-else>
                                        {{ colli.totalVolume }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Weight'">
                                    <div v-if="editableRow==colli.id"
                                         class="d-flex align-items-left bg-white border rounded-lg div-focus
                                            border-2">
                                        <input type="text"
                                               required
                                               autocomplete="off"
                                               class="form-control text-left border-0 py-0 shadow-none form-input"
                                               v-model="colli.totalWeight"
                                               v-on:input="updateColli($event,'weight')"
                                        >
                                    </div>
                                    <div v-else>
                                        {{ colli.totalWeight }}
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Colli'">
                                    <div class="form-group d-flex align-items-center div-focus">
                                        <div
                                            @click="removeSingleColliFromBatch(colli)"
                                            class="material-icons-outlined cursor-pointer text-primary"
                                            title="remove colli">remove
                                        </div>
                                        <span :class="'colli_number_'+colli.id">
                                          {{ colli.totalColliAmountByColliBatch }}
                                            </span>
                                        <div
                                            @click="addSingleColliToBatch(colli)"
                                            class="material-icons-outlined cursor-pointer text-primary"
                                            title="add colli">add
                                        </div>
                                    </div>
                                </slot>
                                <slot v-if="column.label === 'Location'">
                                    <div v-if="editableRow==colli.id || showEditableLocation[colli.id]===true">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div
                                                        class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <v-select
                                                            required
                                                            :clearable="false"
                                                            :clearSearchOnSelect="false"
                                                            :options="locationList"
                                                            v-model="newLocation[colli.id]"
                                                            label="name"
                                                            v-on:input="updateColli($event,'location_id')"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-for="(location,key) in colli.colliBatchLocations">
                                            <span>{{ location }}</span> <br>
                                        </div>
                                    </div>
                                </slot>
                                <slot v-if="column.label === 'Edit'">
                                    <div class="edit-colli" title="Edit Colli" :id="colli.id"
                                         v-on:click="setEditableRow(colli.id)">
                                        <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Delete'">
                                    <div title="delete colli"
                                         @click="deleteCollis(colli.id)"
                                         class="material-icons-outlined cursor-pointer text-primary"
                                         bis_skin_checked="1">
                                        delete
                                    </div>
                                </slot>
                            </td>
                        </tr>
                        </tbody>
                    </data-table>
                    <table class="new-colli" v-for="(item,key) in newColli">
                        <tbody>
                        <tr>
                            <td style="width:7%;"></td>
                            <td>
                                <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                    <v-select
                                        ref="bookingSelector"
                                        class="booking-select"
                                        :clearable="false"
                                        :clearSearchOnSelect="false"
                                        :options="bookingList"
                                        v-model="newColli[key].booking"
                                        label="value"
                                    >
                                    </v-select>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="reference"
                                                       autocomplete="off"
                                                       v-model="newColli[key].reference">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="name"
                                                       autocomplete="off"
                                                       v-model="newColli[key].name">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       autocomplete="off"
                                                       class="form-control text-center  border-0 py-0 shadow-none form-input"
                                                       v-model="newColli[key].volume"
                                                       placeholder="volume"
                                                       value=""
                                                       v-number
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       autocomplete="off"
                                                       class="form-control text-center  border-0 py-0 shadow-none form-input"
                                                       v-model="newColli[key].weight"
                                                       placeholder="weight"
                                                       value=""
                                                       v-number
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="number"
                                                       required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder=""
                                                       autocomplete="off"
                                                       v-model="newColli[key].colli">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td colspan="3"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex" v-if="filters.bookingId!==''">
                    <div>
                        <button
                            class="btn btn-success d-flex align-items-center float-left"
                            title="Receive">
                            <span class="">Receive</span>
                        </button>
                    </div>
                    <div>
                        <div @click="receiveAndPrint()"
                             class="btn btn-info d-flex align-items-center float-left update-colli-data"
                             title="Receive and print">
                            <span class="">Receive and print</span>
                        </div>
                    </div>
                    <div>
                        <div @click="updateColliData()"
                             class="btn btn-primary d-flex align-items-center float-left update-colli-data"
                             title="Save">
                            <span class="">Save</span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from "vue-loading-overlay";

export default {
    name: "ReceiveColli",
    components: {DatePicker, VueTimepicker, Loading},
    props: {
        url: {type: String, required: true},
        sessionData: {type: Array|Object, required: true},
        preDefinedSelections: {type: Array|Object, required: false},
        defaultWarehouse: {type: Object, required: false, default: null},
    },
    data() {
        return {
            isLoading: true,
            loading: false,
            clientList: [
                {id: '', name: ''},
            ],
            bookingList: [
                {
                    id: '',
                    value: '',
                    name: '',
                    volume: '',
                    weight: '',
                    colli: '',
                    client_id: '',
                    client_name: '',
                    reference: ''
                },
            ],
            warehouseList: [
                {id: '', nickname: ''},
            ],
            locationList: [
                {id: '', name: ''},
            ],
            warehouseId: this.sessionData['selectedWarehouse'] ?
                this.sessionData['selectedWarehouse'] :
                (this.defaultWarehouse ? this.defaultWarehouse : {'id': 1, nickname: 'Brøndby'}),
            newLocation: {},
            defaultLocation: {},
            editableRow: null,
            existingColli: {},
            showEditableLocation: {},
            newColli: [],
            collis: {},
            colli: {},
            colliGrouppedByColliBatch: {},
            orderBy: 'id',
            orderDir: 'desc',
            search: '',
            perPage: [100, 10, 25, 50],
            filters: {
                search: '',
                length: 100,
                column: 'id',
                dir: 'desc',
                clientId: this.sessionData['selectedClient'] ? this.sessionData['selectedClient'] : '',
                bookingId: '',
                groupReferences: 0,
                groupByColliBatch: 1,
                excludeDelivered: 0,
                isForColliReceive: true,
            },
            columns: [
                {
                    label: 'Receive',
                    id: '',
                    orderable: false,
                    visible: true,
                },
                {
                    label: 'Booking',
                    id: 'booking',
                    orderable: false,
                    visible: true,
                },
                {
                    label: 'Reference',
                    id: 'reference',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Name',
                    id: 'name',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Volume',
                    id: 'volume',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Weight',
                    id: 'weight',
                    orderable: true,
                    searchable: true,
                    visible: true,
                },
                {
                    label: 'Colli',
                    id: '',
                    orderable: false,
                    visible: true,
                },
                {
                    label: 'Location',
                    id: '',
                    orderable: false,
                    visible: true,
                },
                {
                    label: 'Edit',
                    id: 'edit',
                    orderable: false,
                    visible: true
                },
                {
                    label: 'Delete',
                    id: '',
                    orderable: false,
                    visible: true,
                },
            ],
            pagination: {
                align: "right",
                meta: {to: 1, from: 1}
            },
            translate: {
                nextButton: '',
                previousButton: '',
                placeholderSearch: 'Search'
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            show: false,
            activeModalIntervalPrompt: false,
            activeModalIntervalBatch: false,
            previousBooking: [],
            tmpNewColliAmount: [],
            tmp1: {},
            bookingOrder: [],
            receiveAll: false,
            canRefreshTableWithPreDefined: false,
        }
    },
    methods: {
        sort(key) {
            if (key) {
                this.filters.column = key;
                this.filters.dir = this.filters.dir === 'asc' ? 'desc' : 'asc';
            }
        },
        addRow() {
            this.newColli.push({
                client: this.filters.clientId,
                booking: this.filters.bookingId[0],
                warehouse: 0,
                reference: '',
                name: '',
                volume: 0,
                weight: 0,
                colli: 1
            });
        },
        getBookingList(preSelectedId = null) {
            axios.get(`/booking-list-by-client/${this.filters.clientId.id}/1`)
                .then(({data}) => {
                    this.bookingList = [];
                    this.fillBookingList(data, this.filters.clientId.name, preSelectedId); //@todo
                }).catch();
            this.newColli = [];
            this.collis = {};
            axios.get('/colli-list', {
                params:
                    {
                        search: '',
                        length: 99999,
                        column: 'id',
                        dir: 'desc',
                        clientId: this.filters.clientId,
                        bookingId: preSelectedId ? preSelectedId :'7788',
                        groupReferences: 0,
                        groupByColliBatch: 1,
                        collis: [],
                    }
            }).then(({data}) => {
                Object.entries(data.data).forEach(entry => {
                    const [key, value] = entry;
                    this.tmp1[value.id] = value.totalColliAmountByColliBatch;
                    //this.newLocation[value.id] = this.defaultLocation;
                });
            }).catch();
        },
        fetchData() {
            this.getDefaultLocation();
            this.loading = true;
            axios.get('/client-list')
                .then(({data}) => {
                    this.clients = data.data;
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.clientList.push({
                            id: value.id,
                            name: value.name,
                        });
                    });

                    if (this.preDefinedSelections) {
                        this.setSelectedClientById(this.preDefinedSelections.client_id)
                        this.getBookingList(this.preDefinedSelections.booking_id);
                    }

                    this.canRefreshTableWithPreDefined = true;

                }).catch(error => this.clients = []);
            axios.get('/warehouse-list')
                .then(({data}) => {
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        this.warehouseList.push({
                            id: value.id,
                            nickname: value.nickname,
                        });
                    });
                    this.setDefaultWarehouse();
                }).catch();
            axios.get('/location-list-select')
                .then(({data}) => {
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        this.locationList.push({
                            id: value.id,
                            name: `${value.name} (${value.warehouse.nickname})`,
                        });
                        if (this.preDefinedSelections) {
                            if (value.id === this.preDefinedSelections.location_id) {
                                const locationId = this.preDefinedSelections.location_id;
                                const warehouseId = value.warehouse_id;
                                this.setSelectedWarehouseById(warehouseId);
                            }
                        }
                    });
                }).catch();
        },
        getDefaultLocation() {
            if (this.warehouseId.id === 1) {
                this.defaultLocation.Id = 9;
                this.defaultLocation.name = 'Varemodtagelse';
            } else {
                this.defaultLocation.Id = 10;
                this.defaultLocation.name = 'Varemodtagelse';
            }
        },
        setDefaultWarehouse() {
            const warehouses = this.warehouseList.filter(warehouse => warehouse.id !== '');
            if (!warehouses.length) {
                return;
            }

            const selectedWarehouse = warehouses.find(warehouse => warehouse.id === this.warehouseId.id);
            if (!selectedWarehouse) {
                this.warehouseId = warehouses[0];
            }
            this.getDefaultLocation();
        },
        async receiveGoods() {
            let res = await this.updateColliData();
            if (res) {
                await this.receive(1);
            }
        },
        async receiveAndPrint() {
            let res = await this.updateColliData();
            if (res) {
                res = await this.receive(0);
                if (res) {
                    this.printLabels();
                }
            }
        },
        receive(reload) {
            return new Promise((resolve) => {
                axios.post(`/receive-colli/${this.warehouseId.id}`, this.collis)
                    .then(({data}) => {
                        this.flashMessage.success({
                            title: '',
                            message: `Colli received`,
                            time: 2000,
                            blockClass: 'flash-message'
                        })
                        if (reload) {
                            window.location.href = `/receive-colli`;
                        }
                        resolve(true);
                    }).catch((err) => {
                        this.flashError(err, `Colli data wasn't received`);
                        resolve(false);
                });
            });
        },
        printLabels() {
            this.loading = true;
            let isForClients = 0;
            axios({
                url: `/colli/print-labels?isForClients=${isForClients}&isPrintByBooking=0&groupByBooking=1`,
                method: 'POST',
                data: {ids: this.collis, bookingOrder: this.bookingOrder}
            }).then((response) => {
                this.collis = {};
                if (response.data.printnode === 'missing printer') {
                    alert('PDF generated, but not sent to print since printer id is missing');
                }
                if (response.data.file !== null) {
                    axios({
                        url: `/settings/download-file/print_labels_${response.data.file}`,
                        method: 'GET',
                        responseType: 'blob'
                    }).then((response) => {
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', `print_label.pdf`);
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        window.location.href = `/receive-colli`;
                    }).catch((error) => {
                        this.flashError(error, 'Error upon printing labels');
                    });
                }
            }).catch((error) => {
                this.flashError(error);
            }).finally(() => {
                this.loading = false
            });
        },
        fillBookingList(data, clientName, preSelectedId = null) {
            Object.entries(data.data).forEach(entry => {
                const [key, value] = entry;
                if (clientName === null) {
                    this.bookingList.push({
                        id: value.id,
                        value: `B-${value.id},  ${value.client_data.name}, ${value.dropoff_address != null ? value.dropoff_address.name : ''}, ${value.reference}`,
                        volume: `${value.volume}`,
                        weight: `${value.weight}`,
                        reference: `${value.reference}`,
                        colli: `${value.colli}`,
                        client_id: `${value.client_data.id}`,
                        client_name: `${value.client_data.name}`,
                        colli_batch: `${value.colli_batch}`,
                    });
                } else {
                    this.bookingList.push({
                        id: value.id,
                        value: `B-${value.id}, ${clientName}, ${value.dropoff_address != null ? value.dropoff_address.name : ''}, ${value.reference}`,
                        volume: `${value.total_volume}`,
                        weight: `${value.total_weight}`,
                        reference: `${value.reference}`,
                        colli: `${value.total_colli}`,
                        client_id: `${value.client.id}`,
                        client_name: `${value.client.name}`,
                        colli_batch: `${value.colli_batch}`,
                    });
                }

                if (preSelectedId === value.id) {
                    this.filters.bookingId = [this.bookingList.at(-1)];
                }
            });
            if (clientName === null) {
                this.onChangeBooking();
            }
        },
        onChangeBooking(event) {
            this.collis = {};
            this.bookingOrder = [];
            if(this.filters.bookingId && this.filters.bookingId.length) {
                this.filters.bookingId.forEach(booking => {
                    this.bookingOrder.push(booking.id);
                })
            }
        },
        setEditableRow(id) {
            this.editableRow = id;
        },
        addSingleColliToBatch(colli) {
            if (!this.tmp1[colli.id]) {
                this.tmp1[colli.id] = colli.totalColliAmountByColliBatch;
            }
            this.tmp1[colli.id] += 1;
            colli.totalColliAmountByColliBatch++;
            this.setEditableRow(colli.id);
            if (!this.existingColli[this.editableRow]) {
                this.existingColli[this.editableRow] = {};
            }
            this.existingColli[this.editableRow]['amount'] = this.tmp1[colli.id];
        },
        removeSingleColliFromBatch(colli) {
            if (!this.tmp1[colli.id]) {
                this.tmp1[colli.id] = colli.totalColliAmountByColliBatch;
            }
            if (this.tmp1[colli.id] > 1) {
                this.tmp1[colli.id] -= 1;
                colli.totalColliAmountByColliBatch--;
                this.setEditableRow(colli.id);
                if (!this.existingColli[this.editableRow]) {
                    this.existingColli[this.editableRow] = {};
                }
                this.existingColli[this.editableRow]['amount'] = this.tmp1[colli.id];
            }
        },
        updateColli(event, field) {
            let colliValue = '';
            if (field === 'location_id' || field === 'booking_id' || field === 'client_id') {
                colliValue = event.id;
            } else if (field === 'delivery' || field === 'received_at') {
                colliValue = event;
            } else {
                colliValue = event.target.value;
            }
            if (!this.existingColli[this.editableRow]) {
                this.existingColli[this.editableRow] = {};
            }
            this.existingColli[this.editableRow][field] = colliValue;
            this.showEditableLocation[this.editableRow] = true;
        },
        async updateColliData() {
            await this.saveSelectedValues();
            return new Promise((resolve) => {
                if (this.editableRow > 0 || this.newColli.length > 0) {
                    const requestData = {
                        existingColli: this.existingColli,
                        newColli: this.newColli
                    }
                    axios.post(`/update-multiple-collis`, requestData).then((response) => {
                        this.editableRow = null;
                        this.existingColli = {}
                        this.newColli = [];
                        this.flashMessage.success({
                            title: '',
                            message: `Colli data saved`,
                            time: 1000,
                            blockClass: 'flash-message'
                        });
                        resolve(true);
                    })
                    .catch(err => {
                        this.flashError(err, `Colli data wasn't updated`);
                        resolve(false);
                    })
                } else {
                    resolve(true);
                }
            });
        },
        saveSelectedValues() {
            return new Promise((resolve) => {
                const requestData = {
                    selectedWarehouse: this.warehouseId,
                    selectedClient: this.filters.clientId,
                };
                axios.post(`/receive-colli/save-selected-values`, requestData).then((response) => {})
                    .catch(err => {
                        console.error('saveSelectedValues error');
                        console.error(err.response);
                    }).finally(() => {
                        resolve()
                    });
            });
        },
        deleteCollis(id) {
            if (confirm("Are you sure you want to delete this colli?")) {
                this.collis = {};
                this.collis[id] = true;
                axios.post(`/delete-multiple-collis`, this.collis).then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'The colli has been deleted successfully',
                        time: 1000,
                        blockClass: 'flash-message'
                    });
                    this.$refs.table.getData();
                }).catch((error) => {
                    this.flashError(error);
                }).finally(() => {
                    this.collis = {};
                });
            }
        },
        flashError(error, defaultMassage = 'Error') {
            console.error(error.response);
            this.flashMessage.error({
                title: '',
                message: error.response.data.message || error.response.data ||  defaultMassage,
                time: 2000,
                blockClass: 'flash-message error'
            });

        },
        tableFinishLoading() {
            if (Object.keys(this.existingColli).length) {
                this.$refs.table.tableData.data.forEach((item, key) => {
                    if (this.existingColli[item.id]) {
                        this.$refs.table.tableData.data[key]['reference'] = this.existingColli[item.id]['colli_reference'] !== undefined ? this.existingColli[item.id]['colli_reference'] : this.$refs.table.tableData.data[key]['reference'];
                        this.$refs.table.tableData.data[key]['name'] = this.existingColli[item.id]['name'] !== undefined ? this.existingColli[item.id]['name'] : this.$refs.table.tableData.data[key]['name'];
                        this.$refs.table.tableData.data[key]['totalVolume'] = this.existingColli[item.id]['volume'] !== undefined ? this.existingColli[item.id]['volume'] : this.$refs.table.tableData.data[key]['totalVolume'];
                        this.$refs.table.tableData.data[key]['totalWeight'] = this.existingColli[item.id]['weight'] !== undefined ? this.existingColli[item.id]['weight'] : this.$refs.table.tableData.data[key]['totalWeight'];
                        this.$refs.table.tableData.data[key]['totalColliAmountByColliBatch'] = this.existingColli[item.id]['amount'] !== undefined ? this.existingColli[item.id]['amount'] : this.$refs.table.tableData.data[key]['totalColliAmountByColliBatch'];

                        if (this.existingColli[item.id]['location_id']) {
                            this.locationList.forEach(location => {
                                if (location.id === this.existingColli[item.id]['location_id']) {
                                    this.$refs.table.tableData.data[key]['location'] = JSON.parse(JSON.stringify(location));
                                }
                            })
                        }
                    }
                })
            }
        },
        focusOnBookingSelect() {
            const bookingSelect = document.getElementById('booking-select');
            if (bookingSelect) {
                bookingSelect.value = '';
                this.$nextTick(() => {
                    bookingSelect.focus();
                });
                bookingSelect.focus();
            }
        },
        onReceiveAll() {
            if (this.receiveAll) {
                this.$refs.table.tableData.data.forEach((item, key) => {
                    this.collis[item.id] = true;
                });

            } else {
                this.collis = {};
            }
        },
        setSelectedClientById(searchId) {
            const foundClient = this.clientList.find(client => client.id === searchId);
            if (foundClient) {
                this.filters.clientId = foundClient;
            }
        },
        setSelectedWarehouseById(searchId) {
            const foundWarehouse = this.warehouseList.find(warehouse => warehouse.id === searchId);
            if (foundWarehouse) {
                this.filters.warehouseId = foundWarehouse;
            }
        },
        tableReadyForLoading() {

            if (this.preDefinedSelections) {
                return this.canRefreshTableWithPreDefined;
            } else {
             return true;
            }

        }
    },
    mounted() {
        this.$refs.table.$on("finished-loading", () => {
            this.isLoading = false;
            if (!this.preDefinedSelections) {
                this.focusOnBookingSelect();
            }
        });

        this.$refs.table.$on("loading", () => {
            this.isLoading = true;
        });

    },
    created() {
        this.fetchData();
        if (this.filters['clientId'] && !this.preDefinedSelections) {
            this.getBookingList();
        }
    },
    filters: {
        number: function (value) {
            return value.toLocaleString('da-DK');
        }
    },
}
</script>
<style scoped>

.location-select .vs__dropdown-menu {
    /*width: 600px !important;*/
}

.colli-grouped {
    min-width: 90%;
}

/*.pagination {*/
/*    !*display: none;*!*/
/*}*/

.disabled-colli {
    display: none;
}

.update-colli-data {
    margin-left: 10px;
}

.new-colli th, .new-colli td {
    /* vertical-align: middle; */
}

.new-colli th, .new-colli td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}

.bold-border-top {
    border-top: 5px solid #141414;
}
</style>
